import { render } from "./SidebarParceiro.vue?vue&type=template&id=6d7d0e9c&scoped=true"
import script from "./SidebarParceiro.vue?vue&type=script&lang=js"
export * from "./SidebarParceiro.vue?vue&type=script&lang=js"

import "./SidebarParceiro.vue?vue&type=style&index=0&id=6d7d0e9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7d0e9c"]])

export default __exports__